import { Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import LoginLayout from './components/layout/LoginLayout';
import { AppRoutes } from './axios/endPoints';
import { ProtectedRouting } from './components/routing/ProtectedRouting';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserManagement from './components/user-managment/user-managment';
import { Roles } from './components/layout/menu-items';
import useNotifications from './components/notifications/notifier';
import { useEffect } from 'react';
import { RootState, useAppDispatch, useAppSelector } from './store/store';
import { getLanguages } from './store/app-slice/app';
import AxiosHandler from './axios/axiosHandler';
import MLTester from './components/ml-tester/MLTester';
import MLPrediction from './components/ml-prediction/MLPrediction';
import ColorPicker, { Colors, defaultColors } from './components/common/ColorPicker';
import MLOptimization from './components/ml-optimization/MLOptimization';
import Help from './components/help/Help';
import Old_MLCreator from './components/ml-creator/old_MLCreator';
import MLCreatorSwitcher from './components/ml-creator/MLCreatorSwitcher';
import Old_MLTester from './components/ml-tester/old_MLTester';
import MLTesterSwitcher from './components/ml-tester/MLTesterSwitcher';

function App() {
  const dispatch = useAppDispatch();
  const { languages } = useAppSelector((state: RootState) => state.app);
  useNotifications();
  useEffect(() => {
    if (languages.length === 0) {
      dispatch(getLanguages());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const theme: Colors = JSON.parse(localStorage.getItem("appColors") as string) || defaultColors;

    document.body.style.backgroundColor = theme.backgroundColor;
    document.documentElement.style.setProperty('--button-background-color', theme.buttonBackgroundColor);
    document.documentElement.style.setProperty('--button-text-color', theme.buttonTextColor);
    document.documentElement.style.setProperty('--card-header-background-color', theme.cardHeaderBackgroundColor);
    document.documentElement.style.setProperty('--card-header-text-color', theme.cardHeaderTextColor);
    document.documentElement.style.setProperty('--link-text-color', theme.linkTextColor);
    document.documentElement.style.setProperty('--selected-table-row-color', theme.selectedTableRowColor);
    document.documentElement.style.setProperty('--info-icon-color', theme.infoIconColor);
    document.documentElement.style.setProperty('--download-icon-color', theme.downloadIconColor);
    document.documentElement.style.setProperty('--play-icon-color', theme.playIconColor);
    document.documentElement.style.setProperty('--helper-icon-color', theme.helperIconColor);
    document.documentElement.style.setProperty('--delete-icon-color', theme.deleteIconColor);
    document.documentElement.style.setProperty('--redirect-icon-color', theme.redirectIconColor);
    document.documentElement.style.setProperty('--optimization-icon-color', theme.optimizationIconColor);
  }, []);

  return (
    <Routes>
      <Route path={AppRoutes.LOG_IN} element={<LoginLayout><Login /></LoginLayout>} />
      <Route path={AppRoutes.FORGOT_PASSWORD} element={<LoginLayout><ForgotPassword /></LoginLayout>} />
      <Route path={AppRoutes.RESET_PASSWORD} element={<LoginLayout><ResetPassword /></LoginLayout>} />
      <Route
        path={AppRoutes.ML_CREATOR}
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.MLAdmin, Roles.MLUser]}>
            <MLCreatorSwitcher />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.ML_CREATOR_OLD}
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.MLAdmin, Roles.MLUser]}>
            <Old_MLCreator />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.ML_PREDICTION}
        element={
          <ProtectedRouting>
            <MLPrediction showModelSelection={true} />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.ML_OPTIMIZATION}
        element={
          <ProtectedRouting>
            <MLOptimization showModelSelection={true} />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.ML_TESTER}
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.MLAdmin, Roles.MLUser]}>
            <MLTesterSwitcher/>
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.ML_TESTER_OLD}
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.MLAdmin, Roles.MLUser]}>
            <Old_MLTester />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.COLOR_PICKER}
        element={
          <ProtectedRouting>
            <ColorPicker />
          </ProtectedRouting>
        }
      />
      <Route
        path={`/help/:sectionId`}
        element={
          <ProtectedRouting>
            <Help />
          </ProtectedRouting>
        }
      />
      <Route
        path={'/help'}
        element={
          <ProtectedRouting>
            <Help />
          </ProtectedRouting>
        }
      />
      <Route
        path={AppRoutes.USER_MANAGEMENT}
        element={
          <ProtectedRouting roles={[Roles.Admin, Roles.MLAdmin]}>
            <UserManagement />
          </ProtectedRouting>
        }
      />
    </Routes>
  );
}

export default AxiosHandler(App);
